<div class="tool-card">
  <img alt="User Management" src="./assets/images/paperplane.jpg" />
  <div class="tool-card-body">
    <h3 class="tool-card-label">{{ "report.item.noItems" | translate }}</h3>
    <p>{{ "report.item.noReportsFound" | translate }}</p>
  </div>
</div>
